import { render } from "./field_context_submenu.vue?vue&type=template&id=d2ca59bc"
import script from "./field_context_submenu.vue?vue&type=script&lang=js"
export * from "./field_context_submenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/premiergalop/dev/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__